document.addEventListener("DOMContentLoaded", function () {
  const counters = document.querySelectorAll(".stat__number");
  
  // Tùy chỉnh: Thêm bao nhiêu vòng số 0-9 giả trước khi đến số thật?
  // 2 vòng = tổng 30 số. Tăng lên 5-10 nếu muốn chạy cực nhanh (nhòe mắt).
  const ADDITIONAL_LOOPS = 2; 

  const observerOptions = { threshold: 0.5 };
  
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        if (!el.classList.contains('is-animating')) {
          el.classList.add('is-animating');
          initOdometer(el);
        }
        observer.unobserve(el);
      }
    });
  }, observerOptions);

  counters.forEach(counter => observer.observe(counter));

  function initOdometer(el) {
    const originalText = el.innerText;
    const digits = originalText.replace(/\D/g, "").split(""); 

    el.innerHTML = "";

    digits.forEach((digit, index) => {
      const column = document.createElement("div");
      column.className = "ticker-column";
      
      const list = document.createElement("ul");
      list.className = "ticker-list";
      
      // Tạo danh sách số dài (Lặp lại 0-9 nhiều lần)
      // Vòng lặp tổng = số vòng giả + 1 vòng thật
      const totalRounds = ADDITIONAL_LOOPS + 1;
      
      for (let r = 0; r < totalRounds; r++) {
        for (let i = 0; i <= 9; i++) {
          const item = document.createElement("li");
          item.className = "ticker-item";
          item.textContent = i;
          list.appendChild(item);
        }
      }

      column.appendChild(list);
      el.appendChild(column);

      // Gán cứng chiều cao
      const columnHeight = column.offsetHeight;
      Array.from(list.children).forEach(li => {
          li.style.height = columnHeight + "px";
      });

      // Kích hoạt animation
      setTimeout(() => {
        const targetDigit = parseInt(digit);
        
        // Tính toán vị trí đích:
        // Chúng ta muốn dừng ở số đích nằm trong vòng lặp cuối cùng (vòng thứ 3)
        // Công thức: (Số vòng giả * 10) + Số đích
        const targetIndex = (ADDITIONAL_LOOPS * 10) + targetDigit;
        
        // Tổng số item trong danh sách
        const totalItems = totalRounds * 10;
        
        // Tính phần trăm cần dịch chuyển
        // Ví dụ: Muốn đến item thứ 25 trong tổng 30 item -> Dịch 25/30 * 100 %
        const translateY = (targetIndex / totalItems) * 100 * -1;
        
        list.style.transform = `translateY(${translateY}%)`;
      }, 50 + (index * 150)); 
    });
  }
});